var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "place_black_24dp 1",
    clipPath: "url(#clip0_4091_19862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00065 7.0013C6.35898 7.0013 5.83398 6.4763 5.83398 5.83464C5.83398 5.19297 6.35898 4.66797 7.00065 4.66797C7.64232 4.66797 8.16732 5.19297 8.16732 5.83464C8.16732 6.4763 7.64232 7.0013 7.00065 7.0013ZM10.5007 5.9513C10.5007 3.8338 8.95482 2.33464 7.00065 2.33464C5.04648 2.33464 3.50065 3.8338 3.50065 5.9513C3.50065 7.3163 4.63815 9.12464 7.00065 11.283C9.36315 9.12464 10.5007 7.3163 10.5007 5.9513ZM7.00065 1.16797C9.45065 1.16797 11.6673 3.0463 11.6673 5.9513C11.6673 7.88797 10.1098 10.1805 7.00065 12.8346C3.89148 10.1805 2.33398 7.88797 2.33398 5.9513C2.33398 3.0463 4.55065 1.16797 7.00065 1.16797Z",
    fill: "#808190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_19862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.0ca061d7f321d7e8780dfb28b6f98e02.svg";
export { ForwardRef as ReactComponent };